import modules from './modules';
import sidebar from './sidebar';

const route = {
	path: ':codeProject/apps',
	name: 'page-app',
	meta: {
		title: 'Aplicaciones',
	},
	component: () => import('@/pages/apps/page-app'),
	props: true,
	children: [
		{
			path: 'new',
			name: 'page-app-new',
			meta: {
				title: 'Nueva Aplicación',
			},
			component: () => import('@/pages/apps/page-app-new'),
			props: true,
		},
		{
			path: ':id/edit',
			name: 'page-app-edit',
			meta: {
				title: 'Editar Aplicación',
			},
			component: () => import('@/pages/apps/page-app-new'),
			props: true,
		},
		modules,
		sidebar,
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/apps.js